export default class TestimonialCarousel {

    constructor(el) {
        this.el = el;
        this.quotes = this.el.querySelectorAll('blockquote');
        if (this.quotes && this.quotes[0] && this.quotes[1]) {
            setInterval(() => {
                this.el.insertBefore(this.quotes[1], this.quotes[0]);
                this.quotes = this.el.querySelectorAll('blockquote');
            }, 5000);
        }
    }
}